<template>
  <div class="hero-carousel">
    <vue-carousel
      :data="slides"
      :slide-on-swipe="false"
    />
    <!-- <div class="hero hero8">
      <div class="hero8_content">
        <div class="one">
          <div
            class="one_box"
          />
        </div>

        <div class="two">
          <div
            class="two_box"
          />
          <div
            class="two_box"
          />
        </div>
        <div class="tree">
          <div
            class="tree_box"
            @click="$router.push('/spark')"
          />
        </div>
      </div>
    </div> -->

    <!-- <div class="hero hero9">
      <div class="top_box">
        <div class="top_left">
          <img
            src="~@/assets/newSpark/banner_logo.svg"
            alt=""
          >
        </div>
        <div class="top_right">
          <div>
            <img
              src="~@/assets/newSpark/index_banner_zuijia.svg"
              alt=""
            >
            <img
              src="~@/assets/newSpark/index_banner_2020.svg"
              alt=""
            >
          </div>
          <div class="top_right_button">
            <span>一键选购</span>
            <img
              src="~@/assets/newSpark/icon_arrow_tailed_right.svg"
              alt=""
            >
          </div>
        </div>
      </div>
      <div class="bottom_box">
        <img
          src="~@/assets/newSpark/yinxiang.png"
          alt=""
        >
      </div>
      <div class="bottom_button">
        <div class="top_right_button">
          <span>一键选购</span>
          <img
            src="~@/assets/newSpark/icon_arrow_tailed_right.svg"
            alt=""
          >
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import VueCarousel from '@chenfengyuan/vue-carousel'

export default {
  components: {
    VueCarousel
  },
  data () {
    // let topLeft = require('@/assets/newSpark/banner_logo.svg')
    // let topLeftOne = require('@/assets/newSpark/index_banner_zuijia.svg')
    // let topLeftTwo = require('@/assets/newSpark/index_banner_2020.svg')
    // let bottomBox = require('@/assets/newSpark/yinxiang.png')
    // let bottomButton = require('@/assets/newSpark/icon_arrow_tailed_right.svg')
    return {

      slides: [
        `<div class="hero hero0"></div>`,
        `<div class="hero hero2"><h3>隆重推出</h3><h2>BIAS FX 2 <span>中文版</span></h2><p>音色的新纪元</p><button @click="$router.push('/bias-fx2')">了解更多</button></div>`
      ]
    }
  },

  //   `    <div class="hero hero9" >
  // <div class="top_box">
  //     <div class="top_left" @click="$router.push('/spark')">
  //     <img
  //         src="${topLeft}"
  //         alt=""
  //     >
  //     </div>
  //     <div class="top_right">
  //     <div @click="$router.push('/spark')">
  //         <img
  //         src="${topLeftOne}"
  //         alt=""
  //         >
  //         <img
  //         src="${topLeftTwo}"
  //         alt=""
  //         >
  //     </div>
  //     <div class="top_right_button" onClick="openTmallFun()">
  //         <span>一键选购</span>
  //         <img
  //         src="${bottomButton}"
  //         alt=""
  //         >
  //     </div>
  //     </div>
  // </div>
  // <div class="bottom_box" @click="$router.push('/spark')">
  //     <img
  //     src="${bottomBox}"
  //     alt=""
  //     >
  // </div>
  // <div class="bottom_button">
  //     <div class="top_right_button" onClick="openTmallFun()">
  //         <span>一键选购</span>
  //         <img
  //             src="${bottomButton}"
  //             alt=""
  //         >
  //     </div>
  // </div>
  // </div>`,
  //      `<div class="hero hero0"><a href="/bias-mini-guitar"><h2>BIAS MINI <span>GUITAR</span></h2><p>小身材 大能量</p><button @click="$router.push('/bias-fx2')">了解更多</button></a></div>`,

  created () {
    let _this = this
    window.openTmallFun = _this.openTmallFun
  },
  mounted: function () { },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        window.open('https://m.tb.cn/h.frvinKA?sm=c2dd42?tk=9qBz2jwmxak')
      } else {
        window.open('https://positivegrid.tmall.com/index.htm?spm=a220o.1000855.w5002-23474728891.2.cd3b14817ykKAa')
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base/breakpoint.scss";
@media (max-width: 850px) {
  .hero-carousel {
    .hero0 {
      background: url('');
      margin-left: -16%;
    }
  }
}

.hero-carousel {
  .hero {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 125vw;

    @include breakpoint("medium") {
      min-height: 680px;
    }
  }

  .hero {
    @include breakpoint("medium") {
      background-size: cover;
    }
  }

  .hero0 {
    background-image: url("../assets/banner/banner01.jpg");
  }

  .hero1 {
    background-image: url("../assets/hero/i-shgcdn-2@2x.png");
  }

  .hero2 {
    background-image: url("../assets/hero/i-shgcdn-3@2x.png");
  }

  .hero3 {
    background-image: url("../assets/hero/i-shgcdn-1@2x.png");
  }

  .hero7 {
    cursor: pointer;
    background-image: url("../assets/hero/0618-promo-mobile.png");

    @include breakpoint("medium") {
      background-image: url("../assets/hero/0618-promo-tablet.png");
    }

    @include breakpoint("large") {
      background-image: url("../assets/hero/0618-promo-desktop.png");
    }
  }

  .hero9 {
    background: #e02020;

    .top_box {
      display: flex;
      justify-content: center;

      .top_left {
        width: 320px;
        height: 144px;
        margin-right: 132px;
      }

      .top_right {
        width: 200px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        div {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }

        .top_right_button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 200px;
          height: 44px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 44px;
          color: #e02020;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;

          img {
            margin-left: 6px;
            width: 18px;
            height: 18px;
          }
        }
      }
    }

    .bottom_box {
      display: flex;
      justify-content: center;
      width: 100%;

      img {
        max-width: 656px;
        max-height: 368px;
      }
    }

    .bottom_button {
      display: none;

      .top_right_button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 44px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 44px;
        color: #e02020;
        font-weight: bold;
        font-size: 14px;
        cursor: pointer;

        img {
          margin-left: 6px;
          width: 18px;
          height: 18px;
        }
      }
    }

    @media (max-width: 785px) {

      .top_box {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .top_left {
          width: 100%;
          min-width: 260px;
          height: 132px;
          display: flex;
          justify-content: center;
          margin-top: 50px;
          margin-bottom: 36px;
          margin-right: 0;

          img {
            width: 260px;
            height: 132px;
            margin: 0;
          }
        }

        .top_right {
          width: 180px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          div {
            width: 100%;
            display: flex;
            justify-content: space-between;

            img {
              width: 75px;
            }
          }

          .top_right_button {
            display: none;
          }
        }
      }

      .bottom_box {
        display: flex;
        justify-content: center;
        width: 100%;

        img {
          max-width: 480px;
          max-height: 271px;
        }
      }

      .bottom_button {
        display: flex;
        justify-content: center;
        margin-bottom: 36px;

        .top_right_button {
          width: 144px;
          height: 34px;
          border-radius: 34px;
          font-size: 12px;

          img {
            margin-left: 4px;
            width: 16px;
            height: 16px;
          }
        }
      }
    }

    @media (max-width: 660px) {
      .top_box {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .top_left {
          width: 100%;
          min-width: 200px;
          display: flex;
          justify-content: center;
          margin-top: 50px;
          height: 76px;

          margin-bottom: 16px;

          img {
            width: 200px;
            height: 76px;
            margin: 0;
          }
        }

        .top_right {
          width: 180px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          div {
            width: 100%;
            display: flex;
            justify-content: space-between;

            img {
              // width: 75px;
            }
          }

          .top_right_button {
            display: none;
          }
        }
      }

      .bottom_box {
        display: flex;
        justify-content: center;
        width: 100%;

        img {
          max-width: 336px;
          max-height: 189px;
        }
      }

      .bottom_button {
        display: flex;
        justify-content: center;
        // margin-top:20px;
        margin-bottom: 36px;
      }
    }
  }

  .hero8 {
    background-image: url("../assets/hero/img_spark_kv_bg.jpg");

    @include breakpoint("medium") {
      background-image: url("../assets/hero/img_spark_kv_bg_min.jpg");
    }

    display: flex;
    justify-content: center;
    align-items: center;

    .hero8_content {
      width: 368px;
      height: 484px;

      .one {
        display: flex;
        justify-content: center;
        margin-bottom: 80px;

        .one_box {
          width: 320px;
          height: 163px;
          background: url("../assets/newSpark/banner_logo.svg") no-repeat;
          background-size: 320px 163px;
        }
      }

      .two {
        display: flex;
        justify-content: space-between;
        margin-bottom: 80px;

        .two_box {
          width: 160px;
          height: 120px;
          background: url("~@/assets/newSpark/GuitarPlayer2020 (2).png") no-repeat;
          background-size: 160px 120px;
        }

        .two_box:nth-child(2) {
          width: 160px;
          height: 120px;
          background: url("~@/assets/newSpark/GuitarPlayer2020 (1).png") no-repeat;
          background-size: 160px 120px;
        }
      }

      .tree {
        display: flex;
        justify-content: center;
        margin-bottom: 80px;

        .tree_box {
          width: 200px;
          height: 48px;
          background: url("../assets/newSpark/Default.png") no-repeat;
          background-size: 200px 48px;
        }
      }
    }

    @media (max-width: 558px) {
      .hero8_content {
        width: 230px;
        height: 335px;

        .one {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;

          .one_box {
            width: 210px;
            height: 143px;
            background: url("../assets/newSpark/banner_logo.svg") no-repeat;
            background-size: 210px 143px;
          }
        }

        .two {
          display: flex;
          justify-content: space-between;
          margin-bottom: 40px;

          .two_box {
            width: 100px;
            height: 80px;
            background: url("~@/assets/newSpark/GuitarPlayer2020 (2).png") no-repeat;
            background-size: 100px 80px;
          }

          .two_box:nth-child(2) {
            width: 100px;
            height: 80px;
            background: url("~@/assets/newSpark/GuitarPlayer2020 (1).png") no-repeat;
            background-size: 100px 80px;
          }
        }

        .tree {
          display: flex;
          justify-content: center;

          .tree_box {
            width: 200px;
            height: 48px;
            background: url("../assets/newSpark/Default.png") no-repeat;
            background-size: 200px 48px;
          }
        }
      }
    }
  }

  .hero4 {
    background-image: url("../assets/hero/i-shgcdn@2x.png");
  }

  .hero5 {
    background-image: url("../assets/hero/i-shgcdn-1@2x.png");
  }

  .hero h1,
  .hero p {
    margin: 0;
  }

  .hero p {
    font-weight: 600;
    color: white;
  }

  h2 {
    vertical-align: middle;
    font-size: 40px;

    @include breakpoint("medium") {
      font-size: 80px;
    }

    color: white;
    font-weight: normal;
    margin-bottom: 6px;
    margin-top: 0;
  }

  .hero2 h3 {
    text-align: center;
    display: block;
    color: white;
    margin: 0;
  }

  .hero {
    text-align: center;
  }

  .hero1 h2,
  .hero2 h2 {
    font-weight: 900;
    position: relative;
  }

  .hero0 h2 {
    font-size: 50px;
    font-weight: 600;
  }

  .hero0 h2 span {
    display: inline-block;
    font-weight: 300;
  }

  .hero0 p {
    margin-bottom: 40%;

    @include breakpoint("small") {
      margin-bottom: 20%;
    }
  }

  .hero1 h2 span,
  .hero2 h2 span {
    display: inline-block;
    font-weight: 100;
    font-size: 30px;

    @include breakpoint("medium") {
      font-size: 70px;
    }

    transform: translateY(-2px);
  }

  .hero4 h2 {
    font-size: 60px;
  }

  .hero5 {
    h2 {
      font-size: 40px;

      @include breakpoint("medium") {
        font-size: 60px;
      }

      position: relative;
      margin: 0 auto;
    }

    h2::before {
      background-image: linear-gradient(269deg, #3ae0bd, #1c99ef);
      box-shadow: unset;
      content: "";
      position: absolute;
      height: 3px;
      bottom: 0;
      width: 100%;
    }

    h3 {
      position: relative;
      font-size: 40px;
      color: white;
      margin-top: 0;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  button {
    margin: 0 auto;
    margin-top: 50px;
  }

  .hero0 button {
    @include breakpoint("small") {
      margin-top: 150px;
    }

    @include breakpoint("medium") {
      margin-top: 50px;
    }

    margin-top: 50px;
  }
}

.carousel__item--active {
  z-index: 0 !important;
}

a {
  text-decoration: none;
}

a:link,
a:visited {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/index-hero-carousel.vue